/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TransferSwap, TransferSwapInterface } from "../TransferSwap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_messageBus",
        type: "address",
      },
      {
        internalType: "address",
        name: "_supportedDex",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeWrap",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "srcChainId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
    ],
    name: "DirectSwap",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "messageBus",
        type: "address",
      },
    ],
    name: "MessageBusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "dstAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum TransferSwap.SwapStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "SwapRequestDone",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dstChainId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "srcAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "srcToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "dstToken",
        type: "address",
      },
    ],
    name: "SwapRequestSent",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_executor",
        type: "address",
      },
    ],
    name: "executeMessage",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessageWithTransfer",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_srcChainId",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "executeMessageWithTransferFallback",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_message",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "_executor",
        type: "address",
      },
    ],
    name: "executeMessageWithTransferRefund",
    outputs: [
      {
        internalType: "enum IMessageReceiverApp.ExecutionStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "messageBus",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minSwapAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeWrap",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_messageBus",
        type: "address",
      },
    ],
    name: "setMessageBus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_minSwapAmount",
        type: "uint256",
      },
    ],
    name: "setMinSwapAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nativeWrap",
        type: "address",
      },
    ],
    name: "setNativeWrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_dex",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_enabled",
        type: "bool",
      },
    ],
    name: "setSupportedDex",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_dstChainId",
        type: "uint64",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "dex",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minRecvAmt",
            type: "uint256",
          },
        ],
        internalType: "struct TransferSwap.SwapInfo",
        name: "_srcSwap",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "dex",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minRecvAmt",
            type: "uint256",
          },
        ],
        internalType: "struct TransferSwap.SwapInfo",
        name: "_dstSwap",
        type: "tuple",
      },
      {
        internalType: "uint32",
        name: "_maxBridgeSlippage",
        type: "uint32",
      },
      {
        internalType: "uint64",
        name: "_nonce",
        type: "uint64",
      },
    ],
    name: "transferWithSwap",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_dstChainId",
        type: "uint64",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "dex",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minRecvAmt",
            type: "uint256",
          },
        ],
        internalType: "struct TransferSwap.SwapInfo",
        name: "_srcSwap",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address[]",
            name: "path",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "dex",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minRecvAmt",
            type: "uint256",
          },
        ],
        internalType: "struct TransferSwap.SwapInfo",
        name: "_dstSwap",
        type: "tuple",
      },
      {
        internalType: "uint32",
        name: "_maxBridgeSlippage",
        type: "uint32",
      },
      {
        internalType: "uint64",
        name: "_nonce",
        type: "uint64",
      },
      {
        internalType: "bool",
        name: "_nativeOut",
        type: "bool",
      },
    ],
    name: "transferWithSwapNative",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type TransferSwapConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: TransferSwapConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class TransferSwap__factory extends ContractFactory {
  constructor(...args: TransferSwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TransferSwap";
  }

  deploy(
    _messageBus: string,
    _supportedDex: string,
    _nativeWrap: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<TransferSwap> {
    return super.deploy(_messageBus, _supportedDex, _nativeWrap, overrides || {}) as Promise<TransferSwap>;
  }
  getDeployTransaction(
    _messageBus: string,
    _supportedDex: string,
    _nativeWrap: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_messageBus, _supportedDex, _nativeWrap, overrides || {});
  }
  attach(address: string): TransferSwap {
    return super.attach(address) as TransferSwap;
  }
  connect(signer: Signer): TransferSwap__factory {
    return super.connect(signer) as TransferSwap__factory;
  }
  static readonly contractName: "TransferSwap";
  public readonly contractName: "TransferSwap";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TransferSwapInterface {
    return new utils.Interface(_abi) as TransferSwapInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): TransferSwap {
    return new Contract(address, _abi, signerOrProvider) as TransferSwap;
  }
}
